<template>
  <div class="home">
    <div class="header"></div>
    <slot name="content"></slot>
    <div class="footer"></div>
  </div>
</template>

<script>
    export default {
        name: "common"
    }
</script>

<style scoped lang="less">
  .header{
    background: url("../assets/images/title.png") no-repeat;
    width:14.016rem;
    height:1.248rem;
    background-size: contain;
    margin-top:2.928rem;
    margin-left:1.2rem;
    margin-bottom:0.48rem;
  }
  .footer{
    background: url("../assets/images/footerbg.png") no-repeat;
    background-size: contain;
    width:100%;
    height:3.168rem;
    position: fixed;
    bottom:0;
    z-index: 3;
  }

  /* 如果设备像素大于等于2，则用2倍图 */
  @media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min--moz-device-pixel-ratio: 2) {
    .header {
      background: url("../assets/images/title@2x.png") no-repeat;
      background-size: contain;
    }
    .footer {
      background: url("../assets/images/footerbg@2x.png") no-repeat;
      background-size: contain;
    }
  }
  @media screen and (-webkit-min-device-pixel-ratio: 3), screen and (min--moz-device-pixel-ratio: 3) {
    .header {
      background: url("../assets/images/title@3x.png") no-repeat;
      background-size: contain;
    }
    .footer {
      background: url("../assets/images/footerbg@3x.png") no-repeat;
      background-size: contain;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common.vue